<template>
  <div id="inicio">
    <vue-headful :title="title" />
  
    <bienvenido-nic />

    <div class="cyberpunk-section">
      <div class="circuit-overlay"></div>
      <div class="scanlines"></div>

      <v-container class="content-relative py-16">
        <v-row justify="center">
          <v-col class="text-center" cols="12" md="10">
            <h1 class="text-h3 font-weight-black white--text text-uppercase neon-text tracking-widest mb-2">
              VENTAJAS DE TENER UN DOMINIO .NI
            </h1>
            <div class="subtitle-text cyan--text text--lighten-3 mono-font mt-2">
              > Beneficios de identidad digital segura_
            </div>
          </v-col>
        </v-row>

        <v-row justify="center" class="mt-10">
          <v-col 
            v-for="(item, index) in ventajasList" 
            :key="index"
            cols="12" 
            md="6" 
            lg="5"
            class="d-flex"
          >
            <v-hover v-slot="{ hover }">
              <v-card 
                class="tech-card ma-3 flex-grow-1 d-flex flex-column" 
                :class="{ 'hologram-active': hover }"
                elevation="10"
              >
                <div class="tech-corner top-left"></div>
                <div class="tech-corner top-right"></div>
                
                <v-card-text class="pa-6 d-flex flex-column align-center text-center height-100">
                  
                  <div class="icon-hex mb-6" :style="`border-color: ${item.colorHex}`">
                    <v-icon size="50" :color="item.colorName" :class="{ 'pulse-icon': hover }">
                      {{ item.icon }}
                    </v-icon>
                  </div>

                  <p class="white--text text-body-1 font-weight-light mb-0" style="line-height: 1.6;">
                    {{ item.text }}
                  </p>

                </v-card-text>
                
                <div class="status-bar" :style="`background: ${item.colorHex}`"></div>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-container>
      <card-phone class="phone mt-10" />
      <parnerts class="mt-10" />
    </v-container>
  </div>
</template>

<script>
import vueHeadful from "vue-headful";

export default {
  components: {
    vueHeadful,
    CardPhone: () => import("@/components/CardPhone"),
    Parnerts: () => import("@/components/Parnerts"),
    BienvenidoNic: () => import("@/components/BienvenidoNic"),
  },

  data: () => ({
    title: "Inicio",
    // Datos con Iconos MDI y Colores Tech
    ventajasList: [
      {
        icon: "mdi-shield-check-outline", // Reemplaza imagen de protección
        colorName: "cyan accent-3",
        colorHex: "#00E5FF",
        text: "Protección de tu nombre personal, el de tu institución o negocio y obtienes un nombre fácil de recordar para utilizarlo en Internet a nivel internacional."
      },
      {
        icon: "mdi-map-marker-radius", // Reemplaza imagen de geolocalización
        colorName: "green accent-3",
        colorHex: "#00E676",
        text: "Tu nombre, el de tu institución o tu negocio se posiciona geográficamente en internet, vinculando tu presencia a Nicaragua y haciéndola visible a nivel mundial."
      },
      {
        icon: "mdi-web", // Reemplaza imagen de red
        colorName: "blue accent-3",
        colorHex: "#2979FF",
        text: "Tu sitio web es visible a nivel mundial. Ejemplo: www.nombredemiempresa.com.ni"
      },
      {
        icon: "mdi-email-lock", // Reemplaza imagen de correo
        colorName: "purple accent-3",
        colorHex: "#E040FB",
        text: "Tus correos electrónicos serán institucionalizados o personalizados, brindando mayor profesionalismo y seguridad."
      }
    ]
  }),
};
</script>

<style scoped>
/* Fuentes */
@import url('https://fonts.googleapis.com/css2?family=Fira+Code:wght@400;600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700;900&display=swap');

/* --- SECCIÓN CYBERPUNK ESPECÍFICA --- */
.cyberpunk-section {
  position: relative;
  width: 100vw; /* Ancho completo de ventana */
  left: 50%;
  right: 50%;
  margin-left: -50vw; /* Truco para romper los márgenes del contenedor padre */
  margin-right: -50vw;
  
  background-color: #050a14; /* Fondo negro azulado */
  overflow: hidden;
  font-family: 'Montserrat', sans-serif;
  
  /* Sombra interna para separar visualmente del resto blanco */
  box-shadow: inset 0 0 50px rgba(0,0,0,0.8);
  margin-top: 40px;
  margin-bottom: 40px;
}

.mono-font { font-family: 'Fira Code', monospace !important; }
.tracking-widest { letter-spacing: 2px; }

/* Fondos y Capas */
.circuit-overlay {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  background-image: 
    radial-gradient(circle at 50% 50%, rgba(0, 255, 255, 0.03) 0%, transparent 60%),
    linear-gradient(0deg, rgba(0,0,0,0.2) 50%, transparent 50%);
  background-size: cover, 4px 4px;
  z-index: 1;
}

.scanlines {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  background: linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,0) 50%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.1));
  background-size: 100% 4px;
  pointer-events: none;
  z-index: 1;
}

.content-relative { position: relative; z-index: 2; }

/* Texto Neón */
.neon-text { text-shadow: 0 0 10px rgba(0, 229, 255, 0.6), 0 0 20px rgba(0, 229, 255, 0.3); }

/* Tarjetas Tech */
.tech-card {
  background: rgba(13, 25, 45, 0.85) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 255, 255, 0.15) !important;
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  min-height: 280px;
}

.hologram-active {
  transform: translateY(-5px);
  border-color: rgba(0, 255, 255, 0.6) !important;
  box-shadow: 0 10px 30px rgba(0, 255, 255, 0.15);
}

/* Iconos Decorados */
.icon-hex {
  width: 100px;
  height: 100px;
  border: 2px solid;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  box-shadow: inset 0 0 20px rgba(255, 255, 255, 0.05);
}

.pulse-icon { animation: pulse 2s infinite; }

@keyframes pulse {
  0% { transform: scale(1); filter: drop-shadow(0 0 0px currentColor); }
  50% { transform: scale(1.1); filter: drop-shadow(0 0 10px currentColor); }
  100% { transform: scale(1); filter: drop-shadow(0 0 0px currentColor); }
}

/* Esquinas Tech */
.tech-corner {
  position: absolute;
  width: 15px;
  height: 15px;
  border-color: rgba(255, 255, 255, 0.3);
  border-style: solid;
  transition: all 0.3s;
}
.top-left { top: 0; left: 0; border-width: 2px 0 0 2px; }
.top-right { top: 0; right: 0; border-width: 2px 2px 0 0; }

.hologram-active .tech-corner {
  border-color: cyan;
  width: 25px;
  height: 25px;
}

.status-bar {
  height: 4px;
  width: 100%;
  opacity: 0.7;
}

/* --- ESTILOS GENERALES (Para el resto de la página) --- */
.phone {
  margin-top: 40px;
}

/* Ajustes Responsive */
@media (max-width: 725px) {
  .cyberpunk-section {
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>